import {createStore, applyMiddleware} from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './rootReducer';
import logger from '_app/shared/reduxLogger';
import composeEnhancers from '_app/shared/composeWithDevToolsWrapper';

export default function configureContentAdministrationStore(preloadedState) {
	const middlewares = process.env.NODE_ENV !== 'production' ?
		[thunkMiddleware, require('redux-immutable-state-invariant').default(), logger] :
		[thunkMiddleware];

	return createStore(
		rootReducer,
		preloadedState,
		composeEnhancers(applyMiddleware(...middlewares))
	);
}